import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MatDialogRef,
    MatDialogModule,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ReportCategoryRow } from '../report-categories-page.component';

@Component({
    selector: 'app-delete-report-category-dialog',
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    templateUrl: './delete-report-category-dialog.component.html',
    styleUrl: './delete-report-category-dialog.component.scss',
})
export class DeleteReportCategoryDialogComponent {
    constructor(
        // eslint-disable-next-line no-unused-vars
        public dialogRef: MatDialogRef<DeleteReportCategoryDialogComponent>,
        // eslint-disable-next-line no-unused-vars
        @Inject(MAT_DIALOG_DATA) public data: { mapping: ReportCategoryRow }
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}
